var _clipPath, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenevaStudentsChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 493 239",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "genava-students-charts",
    x: 0,
    y: 0,
    width: 492.754,
    height: 238.049,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.492,
    y: 5.434,
    width: 484.5,
    height: 231.483
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "68.675px",
    y: "233.552px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "High School"), /*#__PURE__*/React.createElement("text", {
    x: "185.113px",
    y: "233.552px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "Univ", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "207.551px ",
    y: "233.552px "
  }, "e")), "rsity"), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-24.508,-21.5663)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "293.949px",
    y: "255.119px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "Appr", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "317.973px ",
    y: "255.119px "
  }, "e")), "nticesh"), /*#__PURE__*/React.createElement("text", {
    x: "361.295px",
    y: "255.119px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "i"), /*#__PURE__*/React.createElement("text", {
    x: "363.9px",
    y: "255.119px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "p DU", _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: "387.781px ",
    y: "255.119px "
  }, "A"))), /*#__PURE__*/React.createElement("text", {
    x: "394.994px",
    y: "255.119px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "L"), /*#__PURE__*/React.createElement("text", {
    x: "412.711px",
    y: "255.119px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "V", _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: "419.202px ",
    y: "255.119px "
  }, "o")), "cational ", _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: "467.711px ",
    y: "255.119px "
  }, "t")), "ra"), /*#__PURE__*/React.createElement("text", {
    x: "481.864px",
    y: "255.119px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "i"), /*#__PURE__*/React.createElement("text", {
    x: "484.47px",
    y: "255.119px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "n"), /*#__PURE__*/React.createElement("text", {
    x: "490.994px",
    y: "255.119px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "i"), /*#__PURE__*/React.createElement("text", {
    x: "493.6px",
    y: "255.119px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "ng")), /*#__PURE__*/React.createElement("text", {
    x: "32.048px",
    y: "222.786px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "0"), /*#__PURE__*/React.createElement("text", {
    x: "9.358px",
    y: "181.065px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "5,", _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: "18.176px ",
    y: "181.065px "
  }, "0")), "00"), /*#__PURE__*/React.createElement("text", {
    x: "4.174px",
    y: "139.344px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "10", _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: "15.458px 17.977px ",
    y: "139.344px 139.344px "
  }, ",0")), "00"), /*#__PURE__*/React.createElement("text", {
    x: "4.364px",
    y: "97.623px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "15,", _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: "17.79px ",
    y: "97.623px "
  }, "0")), "00"), /*#__PURE__*/React.createElement("text", {
    x: "2.65px",
    y: "55.902px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "20", _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: "15.645px 18.165px ",
    y: "55.902px 55.902px "
  }, ",0")), "00"), /*#__PURE__*/React.createElement("text", {
    x: "2.839px",
    y: "14.182px",
    style: {
      fontFamily: "'Rubik-Regular', 'Rubik'",
      fontSize: "10.767px"
    }
  }, "25,", _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: "17.977px ",
    y: "14.182px "
  }, "0")), "00"), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", null, _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.052,
    y: 10.114,
    width: 441.12,
    height: 168.48,
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.851,177.7l440.141,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.851,135.98l440.141,-0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.851,94.259l440.141,-0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.851,52.538l440.141,-0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.851,10.817l440.141,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.052,
    y: 218.674,
    width: 441.12,
    height: 1.44,
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.851,219.421l440.141,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "0.67px"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.851,
    y: 87.074,
    width: 103.728,
    height: 132.347
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.149,87.074l87.131,0c0.545,0 1.085,0.054 1.619,0.16c0.534,0.106 1.053,0.264 1.557,0.472c0.503,0.209 0.981,0.464 1.434,0.767c0.453,0.303 0.873,0.647 1.258,1.032c0.385,0.385 0.729,0.804 1.032,1.257c0.302,0.453 0.558,0.932 0.767,1.435c0.208,0.503 0.366,1.022 0.472,1.557c0.106,0.534 0.159,1.074 0.159,1.619l0,124.048c0,0.545 -0.053,1.085 -0.159,1.619c-0.106,0.534 -0.264,1.053 -0.472,1.557c-0.209,0.503 -0.465,0.981 -0.767,1.434c-0.303,0.453 -0.647,0.873 -1.032,1.258c-0.385,0.385 -0.805,0.729 -1.258,1.032c-0.453,0.303 -0.931,0.558 -1.434,0.767c-0.504,0.208 -1.023,0.366 -1.557,0.472c-0.534,0.106 -1.074,0.159 -1.619,0.159l-87.131,0c-0.545,0 -1.085,-0.053 -1.619,-0.159c-0.534,-0.106 -1.053,-0.264 -1.557,-0.472c-0.503,-0.209 -0.981,-0.464 -1.434,-0.767c-0.453,-0.303 -0.873,-0.647 -1.258,-1.032c-0.385,-0.385 -0.729,-0.805 -1.032,-1.258c-0.303,-0.453 -0.558,-0.931 -0.767,-1.434c-0.208,-0.504 -0.366,-1.023 -0.472,-1.557c-0.106,-0.534 -0.159,-1.074 -0.159,-1.619l-0,-124.048c-0,-0.545 0.053,-1.085 0.159,-1.619c0.106,-0.535 0.264,-1.054 0.472,-1.557c0.209,-0.503 0.464,-0.982 0.767,-1.435c0.303,-0.453 0.647,-0.872 1.032,-1.257c0.385,-0.385 0.805,-0.729 1.258,-1.032c0.453,-0.303 0.931,-0.558 1.434,-0.767c0.504,-0.208 1.023,-0.366 1.557,-0.472c0.534,-0.106 1.074,-0.16 1.619,-0.16Z",
    style: {
      fill: "#0496ff",
      fillRule: "nonzero"
    }
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.989,
    y: 10.976,
    width: 103.728,
    height: 208.446
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.287,10.976l87.131,-0c0.545,-0 1.084,0.053 1.619,0.159c0.534,0.106 1.053,0.264 1.557,0.472c0.503,0.209 0.981,0.464 1.434,0.767c0.453,0.303 0.872,0.647 1.258,1.032c0.385,0.385 0.729,0.804 1.032,1.258c0.302,0.453 0.558,0.931 0.767,1.434c0.208,0.504 0.365,1.022 0.472,1.557c0.106,0.534 0.159,1.074 0.159,1.619l0,200.147c0,0.545 -0.053,1.085 -0.159,1.619c-0.107,0.534 -0.264,1.053 -0.472,1.557c-0.209,0.503 -0.465,0.981 -0.767,1.434c-0.303,0.453 -0.647,0.873 -1.032,1.258c-0.386,0.385 -0.805,0.729 -1.258,1.032c-0.453,0.303 -0.931,0.558 -1.434,0.767c-0.504,0.208 -1.023,0.366 -1.557,0.472c-0.535,0.106 -1.074,0.159 -1.619,0.159l-87.131,0c-0.545,0 -1.085,-0.053 -1.619,-0.159c-0.534,-0.106 -1.053,-0.264 -1.557,-0.472c-0.503,-0.209 -0.981,-0.464 -1.434,-0.767c-0.453,-0.303 -0.873,-0.647 -1.258,-1.032c-0.385,-0.385 -0.729,-0.805 -1.032,-1.258c-0.303,-0.453 -0.558,-0.931 -0.767,-1.434c-0.208,-0.504 -0.366,-1.023 -0.472,-1.557c-0.106,-0.534 -0.159,-1.074 -0.159,-1.619l-0,-200.147c-0,-0.545 0.053,-1.085 0.159,-1.619c0.106,-0.535 0.264,-1.053 0.472,-1.557c0.209,-0.503 0.464,-0.981 0.767,-1.434c0.303,-0.454 0.647,-0.873 1.032,-1.258c0.385,-0.385 0.805,-0.729 1.258,-1.032c0.453,-0.303 0.931,-0.558 1.434,-0.767c0.504,-0.208 1.023,-0.366 1.557,-0.472c0.534,-0.106 1.074,-0.159 1.619,-0.159Z",
    style: {
      fill: "#0496ff",
      fillRule: "nonzero"
    }
  })), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.127,
    y: 172.368,
    width: 103.728,
    height: 47.053
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.425,172.368l87.131,0c0.545,0 1.084,0.054 1.619,0.16c0.534,0.106 1.053,0.264 1.556,0.472c0.504,0.209 0.982,0.464 1.435,0.767c0.453,0.303 0.872,0.647 1.258,1.032c0.385,0.385 0.729,0.804 1.032,1.257c0.302,0.453 0.558,0.932 0.766,1.435c0.209,0.503 0.366,1.022 0.473,1.557c0.106,0.534 0.159,1.074 0.159,1.619l0,38.754c0,0.545 -0.053,1.085 -0.159,1.619c-0.107,0.534 -0.264,1.053 -0.473,1.557c-0.208,0.503 -0.464,0.981 -0.766,1.434c-0.303,0.453 -0.647,0.873 -1.032,1.258c-0.386,0.385 -0.805,0.729 -1.258,1.032c-0.453,0.303 -0.931,0.558 -1.435,0.767c-0.503,0.208 -1.022,0.366 -1.556,0.472c-0.535,0.106 -1.074,0.159 -1.619,0.159l-87.131,0c-0.545,0 -1.085,-0.053 -1.619,-0.159c-0.535,-0.106 -1.053,-0.264 -1.557,-0.472c-0.503,-0.209 -0.981,-0.464 -1.435,-0.767c-0.453,-0.303 -0.872,-0.647 -1.257,-1.032c-0.385,-0.385 -0.729,-0.805 -1.032,-1.258c-0.303,-0.453 -0.558,-0.931 -0.767,-1.434c-0.208,-0.504 -0.366,-1.023 -0.472,-1.557c-0.106,-0.534 -0.159,-1.074 -0.159,-1.619l-0,-38.754c-0,-0.545 0.053,-1.085 0.159,-1.619c0.106,-0.535 0.264,-1.054 0.472,-1.557c0.209,-0.503 0.464,-0.982 0.767,-1.435c0.303,-0.453 0.647,-0.872 1.032,-1.257c0.385,-0.385 0.804,-0.729 1.257,-1.032c0.454,-0.303 0.932,-0.558 1.435,-0.767c0.504,-0.208 1.022,-0.366 1.557,-0.472c0.534,-0.106 1.074,-0.16 1.619,-0.16Z",
    style: {
      fill: "#0496ff",
      fillRule: "nonzero"
    }
  })), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.264,
    y: 184.209,
    width: 103.728,
    height: 35.212
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.563,184.209l87.131,-0c0.545,-0 1.084,0.053 1.619,0.159c0.534,0.107 1.053,0.264 1.556,0.472c0.504,0.209 0.982,0.465 1.435,0.767c0.453,0.303 0.872,0.647 1.257,1.032c0.386,0.386 0.73,0.805 1.032,1.258c0.303,0.453 0.559,0.931 0.767,1.434c0.209,0.504 0.366,1.023 0.473,1.557c0.106,0.534 0.159,1.074 0.159,1.619l0,26.914c0,0.545 -0.053,1.085 -0.159,1.619c-0.107,0.534 -0.264,1.053 -0.473,1.557c-0.208,0.503 -0.464,0.981 -0.767,1.434c-0.302,0.453 -0.646,0.873 -1.032,1.258c-0.385,0.385 -0.804,0.729 -1.257,1.032c-0.453,0.303 -0.931,0.558 -1.435,0.767c-0.503,0.208 -1.022,0.366 -1.556,0.472c-0.535,0.106 -1.074,0.159 -1.619,0.159l-87.131,0c-0.545,0 -1.085,-0.053 -1.619,-0.159c-0.535,-0.106 -1.054,-0.264 -1.557,-0.472c-0.503,-0.209 -0.982,-0.464 -1.435,-0.767c-0.453,-0.303 -0.872,-0.647 -1.257,-1.032c-0.385,-0.385 -0.729,-0.805 -1.032,-1.258c-0.303,-0.453 -0.558,-0.931 -0.767,-1.434c-0.208,-0.504 -0.366,-1.023 -0.472,-1.557c-0.106,-0.534 -0.16,-1.074 -0.16,-1.619l0,-26.914c0,-0.545 0.054,-1.085 0.16,-1.619c0.106,-0.534 0.264,-1.053 0.472,-1.557c0.209,-0.503 0.464,-0.981 0.767,-1.434c0.303,-0.453 0.647,-0.872 1.032,-1.258c0.385,-0.385 0.804,-0.729 1.257,-1.032c0.453,-0.302 0.932,-0.558 1.435,-0.767c0.503,-0.208 1.022,-0.365 1.557,-0.472c0.534,-0.106 1.074,-0.159 1.619,-0.159Z",
    style: {
      fill: "#0496ff",
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenevaStudentsChart);
export default __webpack_public_path__ + "static/media/geneva-students-chart.bf5454753d46910f98fc7301696e4b81.svg";
export { ForwardRef as ReactComponent };